import { borderRadiusSm } from "@airhelp/design-tokens";
const baseStyle = {
    control: {
        bg: "greyscale.100",
        border: "1px",
        borderColor: "greyscale.500",
        borderRadius: borderRadiusSm,
        _focus: {
            boxShadow: "none",
        },
        _checked: {
            bg: "primary.500",
            borderColor: "primary.500",
            _hover: {
                bg: { md: "primary.600" },
                borderColor: { md: "primary.600" },
            },
            _disabled: {
                bg: "greyscale.400",
                borderColor: "greyscale.400",
                color: "greyscale.500",
            },
            _active: {
                bg: "primary.700",
                borderColor: "primary.700",
            },
        },
        _disabled: {
            bg: "greyscale.200",
            borderColor: "greyscale.400",
            pointerEvents: "none",
        },
        _hover: {
            borderColor: { md: "primary.300" },
            _invalid: {
                borderColor: { md: "danger.800" },
            },
        },
        _active: {
            borderColor: "primary.700",
        },
        _invalid: {
            borderColor: "danger.700",
            _checked: {
                borderColor: "primary.500",
                _hover: {
                    borderColor: { md: "primary.500" },
                },
            },
        },
    },
    label: {
        color: "greyscale.700",
        a: {
            textDecoration: "underline",
        },
        _disabled: {
            color: "greyscale.600",
        },
    },
};
const sizes = {
    lg: {
        label: { fontSize: "sm" },
    },
};
const defaultProps = {
    size: "lg",
};
const Checkbox = {
    baseStyle,
    sizes,
    defaultProps,
};
export default Checkbox;
